module.exports = __webpack_public_path__ + "static/img/bofangluyin2.fcb9195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/bofangluyin2.png
// module id = EuwL
// module chunks = 24